import './Antivirus.css';
import pic2 from '../image/pic2.svg'

function antivirus() {
    return (
        <div className="antivirus">

            <div className={'antivirus-content-container'}>
                <div className="antivirus-left">
                    <div className="antivirus-title">
                        What is antivirus?
                    </div>
                    <div className="antivirus-content">
                        An antivirus is a software program used to prevent, detect, and eliminate malware and viruses. It works for all types of devices, such as desktop computers, laptops, smartphones, and tablets. An antivirus usually runs in the background to provide real-time protection without interfering with your browsing experience.
                    </div>
                    <div className="antivirus-title">
                        Why choose Nebular antivirus?
                    </div>
                    <div className="antivirus-content">
                        Usually, free antivirus software offers baseline malware protection that may not be sufficient to combat the ever-evolving threat landscape. Nebular antivirus subscriptions give you up-to-date, advanced security protection against a wide variety of malware and digital threats. Paid solutions also tend to come with richer features and services.
                    </div>
                </div>
                <img className="antivirus-right-image" alt='error-img' src={pic2}/>
            </div>

        </div>
    );
}

export default antivirus